export const options = {
  componentRestrictions: { country: 'us' },
  fields: ['address_components', 'geometry', 'place_id'],
  types: ['address'],
};
